<template>
  <div v-if="loggedInUser" class="mx-auto" style="max-width: 42rem;">
    <h1 class="glitch text-center" data-text="Dashboard">Dashboard</h1>
    <div class="sm:flex">
      <div class="flex-1 sm:mr-8 text-right" style="max-width: 16rem;">
        <h2 class="mb-0" v-text="loggedInUser.name"></h2>
        <span class="text-gray-500" v-text="loggedInUser.email"></span>
        <p>Member Since<br><b v-text="dateJoined"></b></p>
        <p>Stories Rated: <b v-text="storiesByRating.length"></b></p>
      </div>
      <div class="flex-1">
        <h3>Top Stories</h3>
        <StoryPreview
          class="mb-8"
          v-for="id in storiesByRating"
          :key="id"
          :id="id"
        />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex';
import StoryPreview from '@/components/StoryPreview.vue';

export default {
  name: 'dashboard',
  components: {
    StoryPreview,
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'users/loggedInUser',
      stories: 'stories/items'
    }),
    storiesByRating() {
      return Object.entries(this.loggedInUser.ratings) // convert stories object to array
        .sort((a, b) => b[1] - a[1]) // sort high to low
        .map(story => story[0]); // return only IDs
    },
    dateJoined() {
      const joined = new Date(1571112506 * 1000);

      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ];

      const month = months[joined.getMonth()];
      const day = joined.getDate();
      const year = joined.getFullYear();

      return `${month} ${day}, ${year}`;
    }
  },
  methods: {
    ...mapActions({
      fetchStory: 'stories/fetchStory'
    })
  }
};
</script>

<style lang="scss">
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
  grid-gap: 1rem;
}
</style>
